(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["baseform-product-zoom"] && !Shopify.designMode) return;
  try {
    (() => {
  const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

  const getPoint = (event, image) => {
    const rect = image.getBoundingClientRect();
    const hasPointerPosition =
      Number.isFinite(event.clientX) &&
      Number.isFinite(event.clientY) &&
      (event.clientX !== 0 || event.clientY !== 0);

    if (!hasPointerPosition || rect.width === 0 || rect.height === 0) {
      return { x: 0.5, y: 0.5 };
    }

    return {
      x: clamp((event.clientX - rect.left) / rect.width, 0, 1),
      y: clamp((event.clientY - rect.top) / rect.height, 0, 1),
    };
  };

  const setZoom = (config, image, zoomed, point = { x: 0.5, y: 0.5 }) => {
    image.dataset.bfpZoomed = zoomed ? 'true' : 'false';
    image.setAttribute('aria-pressed', zoomed ? 'true' : 'false');
    image.setAttribute(
      'aria-label',
      zoomed ? config.dataset.closeLabel || image.alt || '' : config.dataset.openLabel || image.alt || ''
    );

    if (zoomed) {
      image.style.transformOrigin = `${point.x * 100}% ${point.y * 100}%`;
    } else {
      image.style.transformOrigin = '50% 50%';
    }
  };

  const init = (scope = document) => {
    scope.querySelectorAll('[data-baseform-product-zoom]').forEach((config) => {
      const productInfo = config.closest('product-info') || document;
      const heroImage = productInfo.querySelector('.bfp-product-hero > img');

      if (!heroImage || heroImage.dataset.bfpZoomReady === 'true') return;

      heroImage.dataset.bfpZoomReady = 'true';
      heroImage.dataset.bfpZoomed = 'false';
      heroImage.setAttribute('role', 'button');
      heroImage.setAttribute('aria-pressed', 'false');
      heroImage.setAttribute('aria-label', config.dataset.openLabel || heroImage.alt || '');
      heroImage.tabIndex = 0;
      heroImage.draggable = false;

      heroImage.addEventListener('click', (event) => {
        const isZoomed = heroImage.dataset.bfpZoomed === 'true';
        setZoom(config, heroImage, !isZoomed, getPoint(event, heroImage));
      });

      heroImage.addEventListener('pointermove', (event) => {
        if (heroImage.dataset.bfpZoomed !== 'true' || event.pointerType === 'touch') return;
        const point = getPoint(event, heroImage);
        heroImage.style.transformOrigin = `${point.x * 100}% ${point.y * 100}%`;
      });

      heroImage.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && heroImage.dataset.bfpZoomed === 'true') {
          event.preventDefault();
          setZoom(config, heroImage, false);
          return;
        }

        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        const isZoomed = heroImage.dataset.bfpZoomed === 'true';
        setZoom(config, heroImage, !isZoomed);
      });

      heroImage.addEventListener('dragstart', (event) => event.preventDefault());

      const extra = heroImage.parentElement?.querySelector('.bfp-product-hero__extra');
      if (extra) {
        extra.addEventListener('toggle', () => {
          if (extra.open) setZoom(config, heroImage, false);
        });
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
